/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Manage_PermissionsInputs */

const en_admin_roles_manage_permissions = /** @type {(inputs: Admin_Roles_Manage_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions`)
};

/**
* | output |
* | --- |
* | "Permissions" |
*
* @param {Admin_Roles_Manage_PermissionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_manage_permissions = /** @type {((inputs?: Admin_Roles_Manage_PermissionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Manage_PermissionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_manage_permissions(inputs)
});
export { admin_roles_manage_permissions as "admin.roles.manage_permissions" }